import styled from "styled-components";
import type { PropsWithChildren, CSSProperties } from "react";

export type HorizontalBlockProps = PropsWithChildren<{
	values: (string | number | React.ReactNode)[];
	gap?: string;
	style?: CSSProperties;
	align?: "flex-start" | "center" | "flex-end";
	justify?: "flex-start" | "center" | "flex-end" | "space-between" | "space-around";
}>;

const HorizontalBlockWrapper = styled.div<{
	$gap: string;
	$align: string;
	$justify: string;
}>`
	display: flex;
	flex-direction: row;
	align-items: ${({ $align }) => $align};
	justify-content: ${({ $justify }) => $justify};
	gap: ${({ $gap }) => $gap};
	flex-wrap: wrap;
`;

export const HorizontalBlock = ({
	values,
	gap = "0.5rem",
	style,
	align = "center",
	justify = "flex-start",
}: HorizontalBlockProps) => {
	return (
		<HorizontalBlockWrapper
			$gap={gap}
			$align={align}
			$justify={justify}
			style={style}
		>
			{values.map((value, index) => (
				<div key={`horizontal-block-item-${index}-${String(value)}`}>
					{value}
				</div>
			))}
		</HorizontalBlockWrapper>
	);
}; 